module.exports = __webpack_public_path__ + "img/bg.a1beb5ef.jpg";